import React, { useEffect, useState } from "react";
import logo from "../pictures/TheBestescafflogo.png";
import Sidebar from "../components/Sidebar";
// import { useNavigate } from 'react-router-dom'
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Logo from "../components/Logo";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  addANewVechile,
  adminActions,
  deleteVechicle,
  editVechicle,
  fetchVechicle,
  signOut,
} from "../store/adminSlice";
import FourButtonsTwo from "../components/FourButtonsTwo";
import HeaderScaff from "../components/HeaderScaff";
import escapeHtml from "../functions/Validator";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import $ from "jquery";
$.DataTable = require("datatables.net");

function AddANewVechile() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const dispatch = useDispatch();
  const [needed, setNeeded] = useState(false);
  const _id = useSelector((state) => state.admin._id);
  const [data, setData] = useState({
    vechicleMake: "",
    model: "",
    registration: "",
    MOTDate: "",
    roadTaxDate: "",
    currentMilage: "",
    adminID: _id,
  });

  const newVechicle = useSelector((state) => state.admin.newVechicle);
  const customerSwalAlert = useSelector(
    (state) => state.admin.customerSwalAlert
  );
  const [custommerDetails, setCustommerDetails] = useState(newVechicle);

  const [edit, setEdit] = useState(false);
  const [editID, setEditID] = useState("");
  const [forEdit, setForEdit] = useState({
    vechicleMake: "",
    model: "",
    registration: "",
    MOTDate: "",
    roadTaxDate: "",
    currentMilage: "",
    adminID: _id,
    _id: "",
  });
  const navigate = useNavigate();
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);
  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);
  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);
  const handleSubmit = (e) => {
    console.log("je;;;");
    e.preventDefault();

    if (
      data.vechicleMake === "" ||
      data.model === "" ||
      data.registration === "" ||
      data.MOTDate === "" ||
      data.roadTaxDate === "" ||
      data.currentMilage === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly fill all the inputs.!",
      });
      return;
    }
    dispatch(addANewVechile(data)).then(() => {
      setData({
        vechicleMake: "",
        model: "",
        registration: "",
        MOTDate: "",
        roadTaxDate: "",
        currentMilage: "",
        adminID: _id,
      });
    });
  };

  useEffect(() => {
    setCustommerDetails(newVechicle);
  }, [newVechicle]);

  useEffect(() => {
    dispatch(fetchVechicle({ adminID: _id }));
    setCustommerDetails(newVechicle);
    setTimeout(() => {
      $("#table").DataTable({ pagingType: "simple_numbers", retrieve: true });
    }, 5000);
  }, []);

  useEffect(() => {
    if (customerSwalAlert === "emailDuplicated") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Email already registered.!",
      }).then(() => {
        dispatch(adminActions.removeCustomerSwalAlert());
      });
    }
  }, [customerSwalAlert]);

  const deleteItem = (thtItem) => {
    var nn = { thtItem: thtItem, _id: thtItem._id, adminID: _id };
    dispatch(deleteVechicle(nn));
  };

  const editItem = (thtItem) => {
    setData({
      ...data,
      vechicleMake: thtItem.vechicleMake,
      model: thtItem.model,
      registration: thtItem.registration,
      MOTDate: thtItem.MOTDate,
      roadTaxDate: thtItem.roadTaxDate,
      currentMilage: thtItem.currentMilage,
      adminID: _id,
    });
    setEditID(thtItem._id);
    setEdit(true);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (
      data.vechicleMake === "" ||
      data.model === "" ||
      data.registration === "" ||
      data.MOTDate === "" ||
      data.roadTaxDate === "" ||
      data.currentMilage === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly fill all the inputs.!",
      });
      return;
    }
    setForEdit({
      ...forEdit,
      vechicleMake: data.vechicleMake,
      model: data.model,
      registration: data.registration,
      MOTDate: data.MOTDate,
      roadTaxDate: data.roadTaxDate,
      currentMilage: data.currentMilage,
      adminID: _id,
      _id: editID,
    });
  };
  const onChangeMOTDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setData({ ...data, MOTDate: escapeHtml(newDate) });
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };
  const onChangeRoadTaxDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setData({ ...data, roadTaxDate: escapeHtml(newDate) });
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };
  const handleUpdateCancel = () => {
    setEdit(false);
    setData({
      vechicleMake: "",
      model: "",
      registration: "",
      MOTDate: "",
      roadTaxDate: "",
      currentMilage: "",
      adminID: _id,
    });
  };

  useEffect(() => {
    dispatch(editVechicle(forEdit));
    setData({
      vechicleMake: "",
      model: "",
      registration: "",
      MOTDate: "",
      roadTaxDate: "",
      currentMilage: "",
      adminID: _id,
    });
    setEdit(false);
  }, [forEdit]);

  return (
    <div className="w-full h-full">
      {/* <header className='border-b-2 w-full pt-3 xxl:pt-8 px-8 sm:px-24'> */}
      {/* <img className='w-38 h-14 md:w-[280px] md:h-[100px] xxl:w-[390px] xxl:h-[150px] mb-2 object-contain' src={logo} alt="logo" /> */}
      {/* <Logo/>
        <div className='w-full flex justify-center md:justify-end px-2 sm:px-2 xl:pr-12 mt-2 lg:-mt-5 xxl:-mt-8'>
          <FourButtonsTwo/>
        </div>
      </header> */}
      <HeaderScaff />
      <div
        className={`${
          sidebarOpen ? "" : isNonMobile ? "" : "flex-col"
        } 'w-full flex h-auto p-2 sm:p-6'`}
      >
        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "basis-1/5"
                : "flex justify-center w-full"
              : "hidden"
          } "w-full h-full"`}
        >
          <Sidebar
            setSidebarOpen={setSidebarOpen}
            needed={needed}
            isNonMobile={isNonMobile}
          />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "hidden"
                : "hidden"
              : isNonMobile
              ? "flex w-12 mt-4"
              : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center"
          } h-fit`}
        >
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? ""
                  : ""
                : isNonMobile
                ? ""
                : "hidden"
            } `}
          >
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? "hidden"
                  : "hidden"
                : isNonMobile
                ? "hidden"
                : "flex"
            } `}
          >
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "lg:basis-3/4 w-full flex flex-col"
                : "hidden"
              : "w-full flex flex-col"
          } " "`}
        >
          <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
            <h2 className="text-lg font-medium text-gray-800 mb-4">
              Add Vehicle
            </h2>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
            >
              {/* Left Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Make
                  </label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                    value={data.vechicleMake}
                    onChange={(e) =>
                      setData({
                        ...data,
                        vechicleMake: escapeHtml(e.target.value),
                      })
                    }
                    type="text"
                    placeholder="Enter vehicle make"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Model
                  </label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                    value={data.model}
                    onChange={(e) =>
                      setData({ ...data, model: escapeHtml(e.target.value) })
                    }
                    type="text"
                    placeholder="Enter model"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Registration
                  </label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                    autoComplete="off"
                    value={data.registration}
                    onChange={(e) =>
                      setData({
                        ...data,
                        registration: escapeHtml(e.target.value),
                      })
                    }
                    type="text"
                    placeholder="Enter registration number"
                  />
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    MOT Date
                  </label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                    value={data.MOTDate}
                    onChange={(e) => onChangeMOTDate(e)}
                    type="date"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Road Tax Date
                  </label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                    value={data.roadTaxDate}
                    onChange={(e) => onChangeRoadTaxDate(e)}
                    type="date"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Current Mileage
                  </label>
                  <div className="flex items-center space-x-4">
                    <input
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#66c18a] focus:border-[#66c18a] shadow-sm"
                      value={data.currentMilage}
                      onChange={(e) =>
                        setData({
                          ...data,
                          currentMilage: escapeHtml(e.target.value),
                        })
                      }
                      type="text"
                      placeholder="Enter current mileage"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Form Buttons */}
              <div className="md:col-span-2 flex justify-end pt-4 space-x-3">
                {edit ? (
                  <>
                    <button
                      className="px-4 py-2 bg-[#66c18a] text-white font-medium rounded-md shadow-sm hover:bg-[#59b37d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200"
                      type="button"
                      onClick={(e) => handleUpdate(e)}
                    >
                      Update
                    </button>
                    <button
                      className="px-4 py-2 bg-gray-200 text-gray-800 font-medium rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-colors duration-200"
                      type="button"
                      onClick={handleUpdateCancel}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <button
                    className="px-4 py-2 bg-[#66c18a] text-white font-medium rounded-md shadow-sm hover:bg-[#59b37d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#66c18a] transition-colors duration-200"
                    type="submit"
                  >
                    Save Vehicle
                  </button>
                )}
              </div>
            </form>
          </div>

          <div className="mt-8 bg-white rounded-lg shadow-sm p-4 md:p-6">
            <h2 className="text-lg font-medium text-gray-800 mb-4">
              Vehicle List
            </h2>
            <div className="overflow-x-auto responsive-table">
              <table className="editor_listing_table w-full" id="table">
                <thead>
                  <tr className="bg-[#66c18a] text-white">
                    <th className="py-2 px-3 text-left rounded-tl-md">
                      Vehicle Make
                    </th>
                    <th className="py-2 px-3 text-left">MOT Date</th>
                    <th className="py-2 px-3 text-left">Road Tax Date</th>
                    <th className="py-2 px-3 text-left">Registration</th>
                    <th className="py-2 px-3 text-left">Model</th>
                    <th className="py-2 px-3 text-left">Current Mileage</th>
                    <th className="py-2 px-3 text-left rounded-tr-md">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className=" ">
                  {custommerDetails ? (
                    custommerDetails.map((data) => {
                      const MOTDate = moment(new Date(data.MOTDate)).format(
                        "DD-MM-YYYY"
                      );
                      const roadTaxDate = moment(
                        new Date(data.roadTaxDate)
                      ).format("DD-MM-YYYY");

                      return (
                        <tr className="">
                          {/* <td className='w-1/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm text-center'>{data._id}</td> */}
                          <td className="w-2 /12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                            {data.vechicleMake}
                          </td>
                          <td className="w-1/12 border-[1px] border-gray-300 pl-2 p-1 text-[10px] xxl:text-[13px]">
                            {MOTDate}
                          </td>
                          <td className="w-1/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                            {roadTaxDate}
                          </td>
                          <td className="w-2/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                            {data.registration}
                          </td>
                          <td className="w-2/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                            {data.model}
                          </td>
                          <td className="w-2/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                            {data.currentMilage}
                          </td>
                          <td className=" w-2/12 border-[1px] border-gray-300 p-1">
                            <div className="flex flex-row justify-center space-x-2 xxl:space-x-5 px-4">
                              <div
                                onClick={(e) => editItem(data)}
                                className="flex flex-col items-center"
                              >
                                <EditIcon
                                  sx={{ width: "17px", height: "17px" }}
                                  className="text-lightgreen hover:text-darkgreen cursor-pointer"
                                />
                                <p className="text-[10px] xxl:text-sm">Edit</p>
                              </div>
                              <div
                                onClick={(e) => deleteItem(data)}
                                className="flex flex-col items-center"
                              >
                                <DeleteIcon
                                  sx={{ width: "17px", height: "17px" }}
                                  className="text-lightgreen hover:text-darkgreen cursor-pointer"
                                />
                                <p className="text-[10px] xxl:text-sm">
                                  Delete
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddANewVechile;
